import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
		path: "/",
		component: () => import("@/views/404.vue"),
	},
	{
		path: "/",
		component: () => import("@/components/Layout/Index.vue"),
		children: [{
				path: "agreement",
				component: () => import("@/views/Agreement.vue"),
				meta: {
					hideMenu: true
				}
			},
			{
				path: "form",
				component: () => import("@/views/form/Index.vue"),
			},
			{
				path: "info",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/info/Index.vue"),
			},
			{
				path: 'print-info',
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/PrintInfo.vue"),
			},
			{
				path: 'sign-up',
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/SignUpData.vue"),
			},
			{
				path: 'info-maintain',
				component: () => import("@/views/InfoMaintain.vue"),
			},
			{
				path: "photo",
				component: () => import("@/views/photo/Index.vue"),
			},
			{
				path: "pay",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/Pay.vue"),
			},
			{
				path: "refund",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/Refund.vue"),
			},
			{
				path: "confirm",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/Confirm.vue"),
			},
			{
				path: "admission",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/admission/Index.vue"),
			},
			{
				path: "interview",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/interview/Index.vue"),
			},
			{
				path: "travel",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/travel/Info.vue"),
			},
			{
				path: "travel/form",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/travel/Form.vue"),
			},
			{
				path: "travel/edit",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/travel/Edit.vue"),
			},
			{
				path: "query",
				meta: {
					keepAlive: true
				},
				component: () => import("@/views/Query.vue"),
			},
		]
	},
	{
		path: "/login",
		component: () => import("@/views/Login.vue"),
	},
	{
		path: "/search",
		component: () => import("@/views/search/Index.vue"),
	},
	{
		path: "/:unit",
		component: () => import("@/views/SignUp.vue"),
	},
	{
		path: "/:unit/:test",
		component: () => import("@/views/SignUp.vue"),
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
